import { Calendar } from '@fullcalendar/core'; // Fullcalendar requires a bit of hacking
import dayGridPlugin from '@fullcalendar/daygrid';

export default {
  init() {

  },
  finalize() {
    // Enable or disable the filter items
    function setFilterStatus(disabled = true) {
      if ($('.filter-item').length > 0) {
        $('.filter-item').each(function() {
          $(this).find('.filter-btn-custom').each(function() {
            $(this).prop('disabled', disabled);
          });
          
          $(this).find('.filter-radio-custom').each(function() {
            $(this).prop('disabled', disabled);
          });
        });
      }

      // also disable confirm button on mobile
      $('.mobile-filter-btn').prop('disabled', disabled);
    }

    // Called whenever a filter is changed
    let timeWhenFilterLastChanged = 0;

    function filterChanged(btnClicked = false) {
      if ($(window).width() < 996) {
        // change when button clicked only only mobile
        if (btnClicked) {
          $('.event-items-holder').empty();
          populateEventsLister(1, true);
        }
      } else {
        // gives a grace period before making the AJAX call
        const d = new Date();
        timeWhenFilterLastChanged = d.getTime();

        setTimeout(function() {
          const new_d = new Date();
          if (new_d.getTime() - timeWhenFilterLastChanged >= 1000) {
            $('.event-items-holder').empty();
            populateEventsLister(1);
          }
        }, 2000);
      }
    }

    // AJAX call to populate the page with relevant events items according to filters etc.
    function populateEventsLister(page, isMobile = false) {
      $('#load-more').hide();
      const $filterEventType = $('[name="filter-event-type"]:checked');

      let event_types = 0;
      let timeframe = $('[name="filter-timeframe"]:checked').val();

      if ($filterEventType.length > 0) {
        event_types = [];

        $filterEventType.each(function() {
          event_types.push($(this).val());
        });
      }

      // Disable filters
      setFilterStatus(true);

      // make AJAX call
      $.ajax({
        url: '/wp-json/events-listing-api/v1/get',
        data: {
          page: page,
          event_types: event_types,
          timeframe: timeframe,
        },
      }).done(function(response) {
        const response_data = JSON.parse(response);

        if (response_data.pages > 0) {
          $('#load-more').show();
        }

        response_data.data.forEach((item) => {

          const $eventItem = $('.event-item-wrap-template').clone();
          $eventItem.removeClass('event-item-wrap-template');
          $eventItem.removeClass('d-none');
          $eventItem.addClass('event-item-wrap');

          const itemTitle = item['title'];
          const itemPermalink = item['permalink'];
          const itemLocation = item['location'];
          const itemDate = item['date'];
          const itemColour = item['colour'];

          $eventItem.find('.event-item').addClass('event-item-' + itemColour);
          $eventItem.find('.item-title').html(itemTitle);
          $eventItem.find('.event-item').prop('href', itemPermalink);
          $eventItem.find('.item-location').html(itemLocation);
          $eventItem.find('.item-date').html(itemDate);

          $('.event-items-holder').append($eventItem);
        });

        // Enable filters
        setFilterStatus(false);

        // Close filter box on mobile
        if (isMobile) {
          $('body').removeClass('overflow-hidden');
          $('body').removeClass('dialog-padder');
          $('.filter-wrap').removeClass('wrap-open');

          $('.filter-item').each(function() {
            $(this).find('.filter-body').stop().hide();
          });
        }
      });
    }

    if ($('.filter-select').length > 0) {
      // Turn all select filters into custom filters
      $('.filter-select').each(function() {
        const $filterBody = $(this).parent();
        const selectName = $(this).prop('name');
        const optionValue = $(this).prop('value');
        const optionText = $(this).data('text');

        const $filterOption = $('.filter-btn-custom-template').clone();
        $filterOption.removeClass('filter-btn-custom-template');
        $filterOption.addClass('filter-btn-custom');
        $filterOption.data('select-name', selectName);
        $filterOption.data('option-value', optionValue);
        $filterOption.find('.filter-btn-text').html(optionText);

        $filterBody.append($filterOption);

        if ($(this).is(':checked')) {
          $filterOption.addClass('is-checked');
        }

        // Filter functionality
        $filterOption.on('click', function() {
          const the_selectName = $(this).data('select-name');
          const the_optionValue = $(this).data('option-value');

          const $the_checkbox = $(`[name="${the_selectName}"][value="${the_optionValue}"]`);
          $the_checkbox.prop('checked', !$the_checkbox.prop('checked'));
          $(this).toggleClass('is-checked');

          filterChanged();
        });
      });
    }

    if ($('.filter-radio').length > 0) {
      // Turn all radio filters into custom filters
      $('.filter-radio').each(function() {
        const $filterBody = $(this).parent();
        const selectName = $(this).prop('name');
        const optionValue = $(this).prop('value');
        const optionText = $(this).data('label');

        const $filterOption = $('.filter-radio-custom-template').clone();
        $filterOption.removeClass('filter-radio-custom-template');
        $filterOption.addClass('filter-radio-custom');
        $filterOption.data('select-name', selectName);
        $filterOption.data('option-value', optionValue);
        $filterOption.find('.filter-btn-text').html(optionText);

        $filterBody.append($filterOption);

        if ($(this).is(':checked')) {
          $filterOption.addClass('is-checked');
        }

        // Filter functionality
        $filterOption.on('click', function() {
          const the_selectName = $(this).data('select-name');
          const the_optionValue = $(this).data('option-value');

          const $the_radio = $(`[name="${the_selectName}"][value="${the_optionValue}"]`);
          $the_radio.prop('checked', true);

          $('.filter-radio-custom').each(function() {
            if ($(this).data('select-name') == the_selectName) {
              $(this).removeClass('is-checked');
            }
          });

          $(this).addClass('is-checked');

          filterChanged();
        });
      });
    }

    // Load more
    $('#load-more').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      populateEventsLister($(this).data('page') + 1);
      $(this).data('page', $(this).data('page') + 1);
    });

    // Open and close filter boxes
    if ($('.filter-item').length > 0) {
      $('.filter-item').each(function() {
        const $this_ = $(this);

        $this_.find('.item-head').on('click', function() {
          $this_.toggleClass('item-open');
          $this_.find('.item-body').stop().slideToggle(250);
        });
      });
    }

    // Open and close filter wrap in mobile
    $('.filter-mobile-toggle').on('click', function() {
      $('body').addClass('overflow-hidden');
      $('body').addClass('dialog-padder');
      $('.filter-wrap').addClass('wrap-open');

      $('.filter-item').each(function() {
        $(this).find('.filter-body').stop().show();
      });
    });

    // Click 'Confirm' on mobile
    $('.mobile-filter-btn').on('click', function() {
      filterChanged(true);
    });

    // Close filter wrap on mobile
    $('.mobile-filter-close').on('click', function() {
      $('body').removeClass('overflow-hidden');
      $('body').removeClass('dialog-padder');
      $('.filter-wrap').removeClass('wrap-open');

      $('.filter-item').each(function() {
        $(this).find('.filter-body').stop().hide();
      });
    });

    populateEventsLister(1);

    // View switching
    $('.view-switcher-btn').on('click', function() {
      const viewName = $(this).data('view');

      $(this).parent().attr('data-current-view', viewName);

      $('.view-switch').addClass('d-none');
      $(`.view-switch[data-view="${viewName}"]`).removeClass('d-none');

      // Flicker the calendar, there's a slight styling problem on page load
      $('.fc-next-button').trigger('click');
      $('.fc-prev-button').trigger('click');
      $('.fc-header-toolbar .fc-button-group').detach().appendTo($('.fc-header-toolbar .fc-toolbar-title').parent());
      expanderCreate();
    });

    // Create event expander, used when there are multiple events
    function expanderCreate() {
      // Move fc prev/next group to same side as title
      $('.fc-header-toolbar .fc-button-group').detach().appendTo($('.fc-header-toolbar .fc-toolbar-title').parent());

      // row by row
      $('.fc-daygrid-day').each(function () {
        if ($(this).find('.fc-daygrid-day-events .fc-daygrid-event-harness').length > 2) {
          // more than 2 events found    
    
          // append an expander div
          const $eventExpander = $('<div class="event-expander"></div>');
          $(this).find('.fc-daygrid-day-events').append($eventExpander);
    
          let elementCount = 0;
    
          // move all other events to the div
          $(this).find('.fc-daygrid-day-events .fc-daygrid-event-harness:not(:first-child):not(:nth-child(2))').each(function () {
            elementCount++;
            $(this).detach().appendTo($eventExpander);
          });
    
          // append a view more/less button
          const $viewChanger = $(`<a class="a a-underline btn-expander">+${elementCount} more</button>`);
          $(this).find('.fc-daygrid-day-events').append($viewChanger);
    
          $viewChanger.on('click', function () {
            $eventExpander.stop().slideToggle(200);
            $(this).html() == 'Show less' ? $(this).html('+' + elementCount + ' more') : $(this).html('Show less');
          });

          $viewChanger.on('keydown', function(e) {
            if (e.keyCode == 13 || e.keyCode == 32) {
              e.preventDefault();
              e.stopPropagation();
              $eventExpander.stop().slideToggle(200);
              $(this).html() == 'Show less' ? $(this).html('+' + elementCount + ' more') : $(this).html('Show less');
            }
          });
        }
      });
    }

    // Calendar initialise
    const $calendarObject = $('#calendar-object');
    const calendarEl = $calendarObject.get()[0];

    let calendar = new Calendar(calendarEl, {
      plugins: [
        dayGridPlugin,
      ],
      defaultView: 'dayGridMonth',
      height: 'auto',
    });

    // Add events
    const calendarEvents = $calendarObject.data('events');

    if (calendarEvents.length > 0) {
      calendarEvents.forEach((event) => {
        calendar.addEvent({
          title: event.title,
          start: new Date(event.date + 'T00:00:00'),
          end: (event.end_date == '') ? undefined : new Date(event.end_date + 'T00:00:00'),
          allDay: true,
          url: event.permalink,
          backgroundColor: event.colour,
          borderColor: event.colour,
          textColor: event.textColour,
        });

      });
    }

    calendar.render();

    setTimeout(function() {
      $('.fc-prev-button, .fc-next-button, .fc-today-button').on('click', function () {
        expanderCreate();
      });
    }, 200);
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/template-event-listing.js